<button
  class="close-btn tui-space_left-2"
  *ngIf="context.closeable"
  [title]="closeWord$ | async"
  (click)="close()"
  tuiIconButton
  tuiPreventDefault="mousedown"
  size="s"
  appearance="aitarget-flat"
  icon="tuiIconCloseLarge"
  shape="rounded"
></button>
<h1 class="heading tui-text_h2 tui-space_bottom-10 tui-space_top-8 ait-text-align-center">
  {{ 'Submit your application' | translate }}
</h1>
<tui-loader
  class="demo-request__loader"
  *tuiLet="clientSubscription$ | async as clientSubscription"
  [showLoader]="!clientSubscription"
  [overlay]="true"
>
  <tui-scrollbar class="demo-request__scrollbar">
    <div class="demo-request__inner tui-space_horizontal-8">
      <ng-container
        *ngIf="
          clientSubscription?.status !== 'accepted' &&
            clientSubscription?.status !== 'declined' &&
            clientSubscription?.status !== 'error';
          else emptyTemplate
        "
      >
        <!--Youtube video-->
        <div
          class="demo-request__video"
          *ngIf="
            context.data.clientSubscription === clientSubscriptionTypes.facebookCreative;
            else background
          "
        >
          <h2 class="tui-text_h4 video-label tui-space_bottom-6">
            {{
              'Create tons of videos in seconds using your product catalog and ready-made video templates'
                | translate
            }}.
          </h2>
          <app-youtube-embedded
            class="youtube-embedded tui-space_bottom-3"
            [youtubeTutorVideo]="
              locale === LOCALES.ru
                ? 'https://www.youtube.com/embed/NrVjdbfvmto'
                : 'https://www.youtube.com/embed/n7jLV4hhTsg'
            "
            width="100%"
            height="auto"
          ></app-youtube-embedded>
        </div>
        <!--Youtube video-->

        <!--Background-->
        <ng-template #background>
          <div class="demo-request__bg"></div>
        </ng-template>
        <!--Background-->

        <!--Form-->
        <form class="request-form" [formGroup]="requestForm" (ngSubmit)="sendRequest()">
          <ng-template #contactName>
            <span class="tui-text_bold">{{ 'How is your name' | translate }}*</span>
          </ng-template>
          <label class="tui-space_bottom-4" [tuiLabel]="contactName">
            <tui-input
              [tuiTextfieldLabelOutside]="true"
              formControlName="contact_name"
              tuiTextfieldSize="m"
            >
              {{ 'Enter your name' | translate }}
            </tui-input>
            <ng-container *ngIf="requestForm.get('contact_name').touched">
              <tui-error
                *ngIf="requestForm.get('contact_name').errors?.required"
                [error]="'Name is required' | translate"
              ></tui-error>
            </ng-container>
          </label>
          <ng-template #contactEmail>
            <span class="tui-text_bold">{{ 'Work email' | translate }}*</span>
          </ng-template>
          <label class="tui-space_bottom-4" [tuiLabel]="contactEmail">
            <tui-input
              [tuiTextfieldLabelOutside]="true"
              formControlName="contact_email"
              tuiTextfieldSize="m"
              >example@example.ru</tui-input
            >
            <ng-container *ngIf="requestForm.get('contact_email').touched">
              <tui-error
                *ngIf="requestForm.get('contact_email').errors?.required"
                [error]="'Email is required' | translate"
              ></tui-error>
              <tui-error
                *ngIf="requestForm.get('contact_email').errors?.email"
                [error]="'Email is incorrect' | translate"
              >
              </tui-error>
            </ng-container>
          </label>
          <ng-template #contactPhone>
            <span class="tui-text_bold">{{ 'Phone' | translate }}*</span>
          </ng-template>
          <label class="tui-space_bottom-4" [tuiLabel]="contactPhone">
            <tui-input-phone-international
              [tuiTextfieldLabelOutside]="true"
              [countries]="countries"
              [countryIsoCode]="countryIsoCode"
              formControlName="contact_phone"
              tuiTextfieldSize="m"
            >
            </tui-input-phone-international>
            <ng-container *ngIf="requestForm.get('contact_phone').touched">
              <tui-error
                *ngIf="requestForm.get('contact_phone').errors?.required"
                [error]="'Phone is required' | translate"
              ></tui-error>
              <tui-error
                *ngIf="requestForm.get('contact_phone').errors?.minlength"
                [error]="'Phone is incorrect' | translate"
              ></tui-error>
            </ng-container>
          </label>
          <tui-checkbox-labeled
            class="tui-space_bottom-2"
            size="l"
            formControlName="prefer_whats_app"
          >
            {{ 'I prefer WhatsApp' | translate }}
          </tui-checkbox-labeled>
          <ng-template #contactCompany>
            <span class="tui-text_bold">{{ 'Company' | translate }}*</span>
          </ng-template>
          <label class="tui-space_bottom-4" [tuiLabel]="contactCompany">
            <tui-input
              [tuiTextfieldLabelOutside]="true"
              formControlName="contact_company"
              tuiTextfieldSize="m"
            >
              {{ 'Website' | translate }}
            </tui-input>
            <ng-container *ngIf="requestForm.get('contact_company').touched">
              <tui-error
                *ngIf="requestForm.get('contact_company').errors?.required"
                [error]="'Company is required' | translate"
              ></tui-error>
            </ng-container>
          </label>

          <p class="tui-space_bottom-6 use-terms-message">
            {{ 'I agree to ' | translate }}
            <a
              class="use-terms-message__link"
              [href]="
                locale === LOCALES.ru
                  ? 'https://files.aitarget.tech/site/terms_of_use_aitech.pdf'
                  : 'https://files.aitarget.com/site/policy_en.pdf'
              "
              tuiLink
              target="_blank"
            >
              {{ 'Privacy Policy' | translate }}
            </a>
          </p>

          <button
            class="ait-fullwidth info-button"
            [showLoader]="sendingSubscription$ | async"
            [disabled]="
              clientSubscription?.status === 'error' ||
              clientSubscription?.status === 'in_progress' ||
              requestForm.invalid
            "
            (click)="sendRequest()"
            data-gtm-id="fb_overlays_contact_us"
            tuiButton
            type="button"
            appearance="aitarget-onboarding-on"
          >
            {{
              clientSubscription?.status === 'in_progress'
                ? ('Request has already sended' | translate) +
                  ' ' +
                  (clientSubscription?.created_at | date : 'dd.MM.yy HH:mm:ss')
                : ('Connect with us' | translate)
            }}
          </button>
        </form>
        <!--Form-->
      </ng-container>
      <ng-template #emptyTemplate>
        <tui-notification
          [hasIcon]="true"
          [status]="clientSubscription?.status === 'accepted' ? 'success' : 'error'"
        >
          <span class="ait-font-text-m">{{
            clientSubscription?.status === 'accepted'
              ? 'Already accepted. Please reload the page'
              : clientSubscription?.status === 'declined'
              ? 'Declined'
              : 'Error. Try to reload the page'
          }}</span>
        </tui-notification>
      </ng-template>
    </div>
  </tui-scrollbar>
</tui-loader>
